import type { DatePickerDateType } from '@pba/react-components';
import { type PostContentObjectDetail, createPostContentObjectDetail } from 'models';
import { useMutation } from 'query';
import type { AttahcmentsInputUploadFile } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { useContentObjectCache } from 'features/feed/queries/cache';
import { createPost } from 'features/posts';

type CreatePostMutationData = {
  post: PostRequestData;
  programId: string;
};

type PostRequestData = {
  attachments?: { fileList: AttahcmentsInputUploadFile[] };
  htmlContent: string;
  programTopicId: string;
  publishAt: DatePickerDateType;
  textContent?: string;
  title: string;
  todoDueDate: DatePickerDateType;
};

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
export const useCreatePostMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<PostContentObjectDetail, CreatePostMutationData>({
    async mutationFn({ post, programId }) {
      const response = await createPost({
        body: {
          attachments: post.attachments?.fileList.map((attachment) => ({ id: attachment.response.id })),
          html_content: post.htmlContent,
          program_id: programId,
          program_topic_id: post.programTopicId,
          publish_at: post.publishAt.toISOString(),
          text_content: post.textContent,
          title: post.title,
          todo_due_date: post.todoDueDate.toISOString(),
        },
      });

      return createPostContentObjectDetail(response.data);
    },
    onSuccess(data) {
      cache.create(data);
    },
  });
};
